import type { ListBuilderConfiguration } from '../types';

/**
 * Group Users list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const GROUP_USERS_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-group-users',
			cacheTTL: 600000,
			name: 'Group Users',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'user-name',
					fields: [
						{
							id: 'name-field',
							dataConfig: {
								type: 'template',
								template: '{user.firstName} {user.lastName}',
								templateFields: [],
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h1',
							text: 'Name',
						},
					],
					minWidth: 180,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'firstName',
							objectTable: 'user',
						},
						{
							direction: 'ASC',
							fieldName: 'lastName',
							objectTable: 'user',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'user-email',
					fields: [
						{
							id: 'email-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'user.email',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h2',
							text: 'Email',
						},
					],
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'email',
							objectTable: 'user',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'medium',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'user-phone',
					fields: [
						{
							id: 'phone-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'user.phone',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'phone',
						},
					],
					headers: [
						{
							id: 'h3',
							text: 'Phone',
						},
					],
					sortable: false,
					alignment: 'left',
					widthConfig: {
						mode: 'flexible',
						preset: 'medium',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'actions',
					fields: [
						{
							id: 'actions-dropdown',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'actions_dropdown',
							dropdownActions: [
								{
									id: 'remove-action',
									label: 'Remove',
									iconName: 'trash',
									callbackName: 'removeUser',
									variant: 'danger',
									visibility: 'visible',
									requiredPermission: 'groups:users:manage',
								},
							],
						},
					],
					headers: [
						{
							id: 'actions-header',
							text: '',
						},
					],
					width: 80,
					align: 'center',
					sortable: false,
				},
			],
			sortOrder: 0,
		},
	],
	filters: {
		activeFilters: ['userKeywords'],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/users/:id',
			objectLabel: 'User',
			objectTable: 'user',
			selectedFields: [
				{
					fieldName: 'id',
					fieldLabel: 'ID',
				},
				{
					fieldName: 'firstName',
					fieldLabel: 'First Name',
				},
				{
					fieldName: 'lastName',
					fieldLabel: 'Last Name',
				},
			],
		},
	],
};
